import { ThunkType } from "../../../../../core/store/reducers";
import { getTradeByProductsExcel } from "../api/getTradeByProductsExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../tradeByProductsDataSlice";

export const downloadTradeByProductsExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.tradeByProducts;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getTradeByProductsExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "TradeByProducts.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
